import { blue } from "@material-ui/core/colors";
import Delta from "quill-delta";
import {
  vimeoUrlValidationPattern,
  websiteValidationPattern,
  youtubeUrlValidationPattern,
} from "tools/validations";

type QuillMatcher = (number | ((node: any, delta: Delta) => Delta))[];

function getEmbededYoutubeVideoUrl(url: string): string | null {
  const match = url.match(youtubeUrlValidationPattern);
  if (match && match[5].length === 11) {
    const videoId = match[5];
    const embededUrl = `https://www.youtube.com/embed/${videoId}?showinfo=0`;
    return embededUrl;
  }

  return null;
}

function getEmbededVimeoVideoUrl(url: string): string | null {
  const match = url.match(vimeoUrlValidationPattern);

  if (match) {
    const videoId = match[5];
    const embededUrl = `https://player.vimeo.com/video/${videoId}/`;
    return embededUrl;
  }

  return null;
}

const urlTransformMatcher = [
  Node.TEXT_NODE,
  (node: any, delta: Delta) => {
    const nodeData = node?.data;

    if (typeof nodeData === "string") {
      const isYoutubeUrl = youtubeUrlValidationPattern.test(nodeData);
      const isVimeoUrl = vimeoUrlValidationPattern.test(nodeData);
      const isVideoUrl = isYoutubeUrl || isVimeoUrl;

      if (isVideoUrl) {
        const embededUrl = isYoutubeUrl
          ? getEmbededYoutubeVideoUrl(nodeData)
          : getEmbededVimeoVideoUrl(nodeData);

        return new Delta().insert({
          video: embededUrl,
        });
      }
      const isUrl = websiteValidationPattern.test(nodeData);

      if (isUrl) {
        return new Delta().insert(nodeData, {
          link: nodeData,
          color: blue.A700,
          background: "transparent",
        });
      }
      return delta;
    }
    return delta;
  },
] as QuillMatcher;

export default urlTransformMatcher;
